import React, { useEffect, useState } from "react";
import { Table, Select, Spin } from "antd";
import { getFromlocalstorage } from "../../../../../component/MaHoaDuLieu/MaHoaDuLieu";

const { Option } = Select;

const LichSuNap = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("all");

  const storedData = getFromlocalstorage("data_u");
  const userData = storedData ? JSON.parse(storedData) : null;
  const userId = userData?.id;

  const apiUrl = process.env.REACT_APP_API_BACKEND;

  // Map phương thức giao dịch sang tiếng Thái
  const methodMap = {
    "Nạp tiền pháp định": "ฝากเงิน",
    "Rút tiền pháp định": "ถอนเงิน",
    "Nạp-Crypto": "ฝาก Crypto",
    "Rút-Crypto": "ถอน Crypto",

    // Thêm các trường hợp backend có thể trả về
    deposit: "ฝากเงิน",
    withdraw: "ถอนเงิน",
    "deposit-crypto": "ฝาก Crypto",
    "withdraw-crypto": "ถอน Crypto",
  };

  // Map trạng thái sang tiếng Thái
  const statusMap = {
    "Thành công": "สำเร็จ",
    "Đã hoàn thành": "สำเร็จ",
    "Hoàn thành": "สำเร็จ",

    "Đang xử lý": "กำลังดำเนินการ",
    "Chờ xử lý": "รอดำเนินการ",
    "Đang chờ": "รอดำเนินการ",

    "Thất bại": "ไม่สำเร็จ",
    "Từ chối": "ถูกปฏิเสธ",
    "Đã hủy": "ยกเลิก",
    "Hủy": "ยกเลิก",

    // Trường hợp backend trả tiếng Anh
    success: "สำเร็จ",
    completed: "สำเร็จ",
    pending: "รอดำเนินการ",
    processing: "กำลังดำเนินการ",
    failed: "ไม่สำเร็จ",
    rejected: "ถูกปฏิเสธ",
    cancelled: "ยกเลิก",
    canceled: "ยกเลิก",
  };

  const columns = [
    {
      title: "เวลา",
      dataIndex: "time",
      key: "time",
      width: 150,
    },
    {
      title: "ช่องทางการทำรายการ",
      dataIndex: "method",
      key: "method",
      width: 200,
      render: (value) => methodMap[value] || value,
    },
    {
      title: "จำนวนเงิน",
      dataIndex: "amount",
      key: "amount",
      width: 150,
      render: (val) =>
        `${(Number(val || 0) / 1000).toLocaleString("en-US")} THB`,
    },
    {
      title: "ค่าธรรมเนียม/โบนัส",
      dataIndex: "feeOrBonus",
      key: "feeOrBonus",
      width: 200,
      render: () => "0 THB",
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (value) => statusMap[value] || value,
    },
  ];

  useEffect(() => {
    if (!userId) {
      setData([]);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await fetch(
          `${apiUrl}/getlichsugd/${userId}`
        );

        const json = await res.json();

        const formatted = json.map((item, index) => ({
          key: index,
          time: item.created,
          method: item.type,
          amount: item.amount,
          feeOrBonus: 0,
          status: item.status,
        }));

        setData(formatted);
      } catch (err) {
        console.error(
          "เกิดข้อผิดพลาดในการโหลดประวัติ:",
          err
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, apiUrl]);

  // Filter vẫn dùng giá trị gốc backend
  const filteredData =
    filterType === "all"
      ? data
      : data.filter(
        (item) => item.method === filterType
      );

  return (
    <div className="box-history margin_top_none">
      <div style={{ marginBottom: 10 }}>
        <Select
          value={filterType}
          onChange={(value) =>
            setFilterType(value)
          }
          style={{ width: 200 }}
        >
          <Option value="all">
            ทั้งหมด
          </Option>

          <Option value="Nạp tiền pháp định">
            ฝากเงิน
          </Option>

          <Option value="Rút tiền pháp định">
            ถอนเงิน
          </Option>

          <Option value="Nạp-Crypto">
            ฝาก Crypto
          </Option>

          <Option value="Rút-Crypto">
            ถอน Crypto
          </Option>
        </Select>
      </div>

      <div className="table-history">
        {loading ? (
          <Spin tip="กำลังโหลดข้อมูล..." />
        ) : (
          <Table
            dataSource={filteredData}
            columns={columns}
            pagination={{
              pageSize: 5,
            }}
            locale={{
              emptyText: "ไม่มีข้อมูล",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default LichSuNap;